import React from "react";
import { connect } from "dva";
import { templateConfig, reduxTemplateConfig } from "./config";
import { framework_tool, component_tool } from '@/tool';
import { getDetailRecord } from '@/containers/content/util'

let { WizContainer, WizReduxTemplate } = framework_tool;
let { WizBrowserExport } = component_tool;

class PracticeRankDate extends WizContainer {
  componentName = 'PracticeRankInfo';

  constructor(props) {
    super(props);
    this.detailInfo = getDetailRecord(props.history);
    this.state = {
      practiceId: this.detailInfo.practiceId,
      record: this.detailInfo
    };
  }

  _handleFile(nextProps, nextState, key) {
    let o = nextProps[key]
    let columnDefs = [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'left',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
        },
      },
      {
        headerName: '排名',
        field: 'rank',
        width: 20,
      },
      {
        headerName: '姓名',
        field: 'fullName',
        searchItem: {},
        width: 20,
      },
      {
        headerName: '账号',
        field: 'userName',
        searchItem: {},
        width: 20,
      },
      {
        headerName: '账号状态',
        field: 'accountState',
        width: 10,
      },
      {
        headerName: '任职信息',
        field: 'userIdentityInfoListStr',
        width: 35,
      },
      {
        headerName: '练习次数',
        field: 'count',
        width: 20,
      },
      {
        headerName: '答对总题数',
        field: 'correctAllNum',
        width: 20,
      },
      {
        headerName: '习题总数',
        field: 'questionAllNum',
        width: 20,
      },
      {
        headerName: '最优正确率',
        field: 'maxAccuracy',
        width: 20,
      },
      {
        headerName: '平均正确率',
        field: 'avgAccuracy',
        width: 20,
      },
      {
        headerName: '总答题时长(秒)',
        field: 'allDuration',
        width: 20,
      },
      {
        headerName: '平均练习时长(秒)',
        field: 'avgDuration',
        width: 20,
      },
    ]
    if (o['success']) {
      let data = o['data']
      data && data.length && data.forEach(d=>{
        if (d.userIdentityInfoList && d.userIdentityInfoList.length){
          let userIdentityInfoListStr = '';
          d.userIdentityInfoList.forEach(_d => {
            if (userIdentityInfoListStr===''){
              userIdentityInfoListStr = _d.positionName+' - '+_d.orgName;
            }else {
              userIdentityInfoListStr = userIdentityInfoListStr +'、'+ _d.positionName+' - '+_d.orgName;
            }
          })
          d['userIdentityInfoListStr']=userIdentityInfoListStr;
        }
        if (d.accountState!=null){
          d['accountState']=d.accountState===1 ? '激活':'禁用';
        }
        d.avgAccuracy = d.avgAccuracy + '%'
        d.maxAccuracy = d.maxAccuracy + '%'
      })
      WizBrowserExport({
        title: '日排行信息',
        sheetName: '日排行信息',
        columns: columnDefs.filter((_, index) => index),
        rows: data,
        filename: '日排行信息.xlsx'
      })
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _render() {
    const { record } = this.state
    let _reduxTemplateConfig = reduxTemplateConfig({
      templateConfig: templateConfig(record),
      apiDataFormat: {
        export: this._handleFile
      },
      practiceInfo: record
    })
    return <>
      <WizReduxTemplate {..._reduxTemplateConfig} />
    </>
  }
}

const mapStateToProps = (state, ownProps) => {
  return {}
};

export default connect(mapStateToProps)(PracticeRankDate);

